import PdpLayout from "@/components/pdp/PdpLayout";
import { EYE_REPAIR } from "@/data/eyeRepair";

export default function PdpConceptV2() {
  return <PdpLayout data={EYE_REPAIR} />;
}
